import { PagedResponse } from './../models/paged-response.model';
import { inject, Injectable, Service } from '@angular/core';
import { BasicHttpClientService } from './basic-http-client.service';
import { map, shareReplay } from 'rxjs/operators';
import { CountryDTO } from '../utilities/countries.models';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'environments/environment';
import { max } from 'moment';

@Service()
export class CountriesService {
  private readonly baseUrl: string = environment.urls.apiUrl.url;
  private countriesCache$: Observable<{ totalCount: number; items: CountryDTO[] }> = null;

  private readonly _httpClient = inject(BasicHttpClientService);

  /**
   * Restituisce tutti i paesi, facendo la richiesta HTTP una sola volta.
   * Tutti i subscriber successivi ricevono i dati dalla cache.
   */
  getAllCountries(
    loaderId: string,
    sorting: string,
    skipCount: number,
    iso2?: string,
    iso3?: string,
    search?: string,
    maxResultCount: number = 300,
  ): Observable<{ totalCount: number; items: CountryDTO[] }> {
    if (!this.countriesCache$) {
      const params = {
        sorting,
        skipCount,
        ...(iso2 && { iso2 }),
        ...(iso3 && { iso3 }),
        ...(search && { search }),
        ...(maxResultCount !== undefined && { maxResultCount })
      };

      this.countriesCache$ = this._httpClient
        .get<PagedResponse<CountryDTO>>(
          `${this.baseUrl}/countries`,
          { params },
          loaderId
        )
        .pipe(
          map(response => ({
            totalCount: response.totalCount,
            items: response.items.map(c => ({
              id: c.id,
              iso2: c.iso2,
              iso3: c.iso3,
              name: c.name
            }))
          })),
          shareReplay(1)
        );
    }

    return this.countriesCache$;
  }


  getCountryById(loaderId: string, id: number) {
    return this._httpClient.get<CountryDTO>(`${this.baseUrl}/countries/${id}`, {}, loaderId);
  }

  resetCache() { //il servizio continuerà a ricordare il valore finché il servizio esiste, anche se il componente viene distrutto, bisogna quindi eliminare la cache
    this.countriesCache$ = null;
  }
}
